import Vue from 'vue'

// 首字母大写 | 其他
Vue.directive('ucstr', {
  inserted (el, binding) {
    let _value = binding.value.toLocaleLowerCase()
    el.innerText = _value.slice(0, 1).toUpperCase() + _value.slice(1)
  }
})

Vue.filter('ucstr', function (value) {
  let _value = value.toLocaleLowerCase()
  return _value.slice(0, 1).toUpperCase() + _value.slice(1)
})

// 单位
Vue.prototype.$ucUnit = function (path, count) {
  if (path && /^measure_/.test(path)) {
    return this.$tc(path, count, { count })
  }
  return `${(count || '')}${(path || '')}`
}
